import { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';

const LoginCallback = ({ errorComponent, loadingElement: LoadingElement = null, onAuthResume }) => {
  const { instance, accounts } = useMsal();
  const [callbackError, setCallbackError] = useState(null);

  useEffect(() => {
    // Check if interaction is required first (similar to Okta's isInteractionRequired check)
    const isInteractionRequired = () => {
      // In MSAL, check if we have no active account and no accounts - might need interaction
      const activeAccount = instance.getActiveAccount();
      return !activeAccount && accounts.length === 0;
    };

    if (onAuthResume && isInteractionRequired()) {
      onAuthResume();
      return;
    }

    // Handle the redirect (equivalent to oktaAuth.handleLoginRedirect())
    const handleRedirect = async () => {
      try {
        // MSAL should be initialized at app level, just handle the redirect
        await instance.handleRedirectPromise();
      } catch (e) {
        console.error('Login callback error:', e);
        setCallbackError(e);
      }
    };

    handleRedirect();
  }, [instance, accounts, onAuthResume]);

  const displayError = callbackError;

  // Preserve original Okta error handling logic but adapt for Entra
  if (displayError?.message?.includes('not assigned') || displayError?.message?.includes('unauthorized')) {
    return (
      <div className="aligned">
        <h1>Unauthorized</h1>
        <p>Sorry, you need to request access to use the Generative AI Sandbox.</p>
        {/* TBD what will be the name to used in the servicenow */}
        {/* <p>
        Click the button below to be taken to ServiceNow to submit an access request. Be sure
        to select "Generative AI Sandbox" in the Application field.
      </p>
        <a
        rel="noopener noreferrer"
        href="https://coxauto.service-now.com/ess?id=sc_cat_item&sys_id=b9e1b825db965304143b69c3ca9619dc"
      >
        <Button>Request Access</Button>
      </a> */}
      </div>
    );
  }

  if (displayError?.name && displayError?.message) {
    return (
      <p>
        {displayError.name}: {displayError.message}
      </p>
    );
  }

  if (displayError) {
    return <p>Error: {displayError.toString()}</p>;
  }

  return <LoadingElement />;
};

export default LoginCallback;